import type { Quiz } from '../types/quiz'
import { formatAttempts, formatTimeLimit } from '../lib/quiz-ui'

import { AppLink } from '@/shared/lib/router'
import { cn } from '@/shared/lib/utils'

interface QuizListItemProps {
  quiz: Quiz
}

export function QuizListItem({ quiz }: QuizListItemProps) {
  return (
    <AppLink
      href={`/quizzes/${quiz.id}`}
      className={cn('clickable-list-item block')}
    >
      <div className="flex items-center gap-3">
        <img
          src="/icons/quizzes.svg"
          alt=""
          className="size-10 shrink-0 drop-shadow-sm"
          aria-hidden
        />
        <div className="min-w-0 grow">
          <p className="truncate font-bold text-jacaranda">{quiz.name}</p>
          <p className="text-sm text-[#7F7FAD]">
            {quiz.questions_per_attempt} pergunta(s) ·{' '}
            {quiz.point_reward_per_correct} pts por acerto
          </p>
          <p className="text-xs font-semibold text-[#7F7FAD]">
            {formatTimeLimit(quiz.time_limit_in_seconds)} ·{' '}
            {formatAttempts(quiz.max_attempts)}
          </p>
          {quiz.current_score ? (
            <p className="mt-1 text-xs font-bold text-jacaranda">
              Sua pontuação: {quiz.current_score.correct_count}/
              {quiz.current_score.total_count} · {quiz.current_score.points_awarded} pts
            </p>
          ) : null}
        </div>
        <span className="shrink-0 text-sm font-bold text-jacaranda" aria-hidden>
          →
        </span>
      </div>
    </AppLink>
  )
}
